import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Paper } from "@mui/material";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { Layout, Text, Table } from "$components";
import useStockList from "$hooks/Stock/useStockList";
import useJStyles from "$hooks/useJStyles";
import { appState } from "$reducers";
import useURLQuery from "$hooks/useURLQuery";
import useCompany from "$hooks/useCompany";
import { StockCompanySelect } from "./StockCompanySelect";
import { CompanyServices } from "$services";
import { CompanyType } from "$types";
import { CacheInvalidationAction } from "$utils/cache";
import useAuth from "$hooks/useAuth";

function Stock() {
  const urlQuery = useURLQuery();
  const contributorId = urlQuery.get("contributor");
  const navigate = useNavigate();
  const { isClient, isContributor } = useCompany();
  // @todo: check with tristan la diff entre iscontributor usecompany et useauth
  const { isContributor: isContributorAuth } = useAuth();
  const { jclasses } = useJStyles();

  const { data: contributor } = useQuery({
    queryKey: [CacheInvalidationAction.GET_COMPANY_BY_ID, contributorId],
    queryFn: () => CompanyServices.getCompanyById(contributorId),
    enabled: !!contributorId,
    staleTime: 60 * 1000,
  });

  const { tableData, classes } = useStockList(contributor, {
    companyFilters: {
      $inCompanyTypes: [
        CompanyType.CLIENT,
        // CompanyType.CONTRIBUTOR,
        // CompanyType.LOGISTICIAN,
      ],
    },
    includeRelatedFiles: true,
  });
  const { filter: companySidebarFilter } = useSelector(appState);

  useEffect(() => {
    if (companySidebarFilter) {
      const { _id, companyTypes } = companySidebarFilter;
      if (isClient(companyTypes)) {
        navigate(`/stock/${companySidebarFilter._id}`);
      }
      if (isContributor(companyTypes) && !contributorId) {
        const params = new URLSearchParams();
        params.append("contributor", _id);
        navigate(`/stock?${params}`);
      }
    }
  }, [
    companySidebarFilter,
    contributor?.data,
    contributorId,
    navigate,
    isClient,
    isContributor,
  ]);

  return (
    <div className={jclasses.jWrapper}>
      <Layout
        title={`Liste des stocks${
          contributor
            ? ` client - ${contributor.name}`
            : isContributorAuth()
              ? ` client`
              : ""
        }`}
        renderHead={() => <StockCompanySelect />}
      >
        <Paper className={jclasses.jPaper}>
          <Table
            bodyData={tableData.bodyData}
            thead={tableData.thead}
            rowsPerPage={50}
            pageName="stockList"
          />
          {!tableData?.bodyData?.length && (
            <div className={classes.noResultPlaceHolder}>
              <Text type="h3">Aucune entreprise trouvée</Text>
            </div>
          )}
        </Paper>
      </Layout>
    </div>
  );
}

export default Stock;
